import React from "react";
import Modal from "../../../../components/Modal";

export default function ChildDeleteModals({
  canDelete,
  canMoveToAlumni,
  showChoiceModal,
  showPermanentDeleteModal,
  showForceDeleteModal,
  canForceDelete,
  showReferenceModal,
  showAlumniSuccessModal,
  actionError,
  deleteReference,
  childName,
  recommendAlumni,
  processing,
  labels,
  onMoveToAlumni,
  onRequestPermanentDelete,
  onConfirmPermanentDelete,
  onRequestForceDelete,
  onConfirmForceDelete,
  onCancel,
  onCloseReference,
  onCloseAlumniSuccess,
  onCopyReference,
}) {
  return (
    <>
      {canDelete && showChoiceModal && (
        <Modal
          show={showChoiceModal}
          title={labels.choiceTitle}
          type={actionError ? "error" : "manage"}
          variant="lds"
          onClose={processing ? () => {} : onCancel}
          dialogClassName="sm:!w-[min(92vw,38rem)] sm:!max-w-none"
          footer={
            <div className="mt-6 grid gap-3 border-t border-slate-200 pt-5 dark:border-slate-700 sm:grid-cols-[auto_minmax(0,1fr)_minmax(0,1fr)] sm:items-stretch">
              <button
                type="button"
                onClick={onCancel}
                disabled={processing}
                className="min-h-11 rounded-xl border border-slate-300 bg-white px-4 py-2.5 text-sm font-bold text-slate-700 transition hover:border-slate-400 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
              >
                {labels.cancel}
              </button>
              <button
                type="button"
                onClick={onRequestPermanentDelete}
                disabled={processing}
                className={`min-h-11 rounded-xl border border-red-200 bg-white px-4 py-2.5 text-sm font-bold leading-5 text-red-700 transition hover:border-red-300 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 disabled:cursor-not-allowed disabled:opacity-50 dark:border-red-500/40 dark:bg-slate-900 dark:text-red-200 dark:hover:bg-red-950/30 ${
                  recommendAlumni ? "" : "ring-1 ring-red-100 dark:ring-red-900"
                }`}
              >
                {labels.deletePermanently}
              </button>
              {canMoveToAlumni && (
                <button
                  type="button"
                  onClick={onMoveToAlumni}
                  disabled={processing}
                  autoFocus
                  className="min-h-11 rounded-xl bg-indigo-600 px-4 py-2.5 text-sm font-bold leading-5 text-white shadow-sm transition hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-indigo-500 dark:hover:bg-indigo-400"
                >
                  {processing ? labels.processing : labels.moveToAlumni}
                </button>
              )}
            </div>
          }
        >
          <div className="space-y-4 text-left text-sm leading-6 text-slate-600 dark:text-slate-300">
            <p>{labels.choiceExplanation}</p>
            <p className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 font-bold text-slate-950 dark:border-slate-700 dark:bg-slate-800/70 dark:text-white">
              {childName}
            </p>
            {recommendAlumni && <p className="font-semibold text-emerald-700 dark:text-emerald-300">{labels.recommended}</p>}
            {!canMoveToAlumni && <p className="font-semibold text-amber-700 dark:text-amber-300">{labels.noAlumniPermission}</p>}
            {actionError && <p role="alert" className="font-semibold text-red-600 dark:text-red-300">{actionError}</p>}
          </div>
        </Modal>
      )}

      {canDelete && showPermanentDeleteModal && (
        <Modal
          show={showPermanentDeleteModal}
          title={labels.permanentTitle}
          type="error"
          variant="lds"
          onClose={processing ? () => {} : onCancel}
          dialogClassName="sm:!w-[min(92vw,32rem)] sm:!max-w-none"
          footer={
            <div className="mt-6 grid gap-3 border-t border-slate-200 pt-5 dark:border-slate-700 sm:grid-cols-2">
              <button type="button" onClick={onCancel} disabled={processing} className="min-h-11 rounded-xl border border-slate-300 bg-white px-4 py-2.5 text-sm font-bold text-slate-700 transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800 disabled:opacity-50">
                {labels.cancel}
              </button>
              <button
                type="button"
                onClick={onConfirmPermanentDelete}
                disabled={processing}
                autoFocus
                className="min-h-11 rounded-xl bg-red-600 px-4 py-2.5 text-sm font-bold text-white shadow-sm transition hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
              >
                {processing ? labels.processing : labels.confirmPermanent}
              </button>
            </div>
          }
        >
          <div className="space-y-3 text-sm leading-6 text-slate-700 dark:text-slate-200">
            <p className="font-bold text-red-700 dark:text-red-300">{labels.permanentWarning}</p>
            <p>{childName}</p>
            {actionError && <p role="alert" className="font-semibold text-red-600 dark:text-red-300">{actionError}</p>}
            {canForceDelete && (
              <button
                type="button"
                onClick={onRequestForceDelete}
                disabled={processing}
                className="min-h-11 w-full rounded-xl border border-red-300 bg-white px-4 py-2.5 text-sm font-bold text-red-700 transition hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 disabled:cursor-not-allowed disabled:opacity-50 dark:border-red-500/40 dark:bg-slate-900 dark:text-red-200 dark:hover:bg-red-950/30"
              >
                {labels.forceDelete}
              </button>
            )}
          </div>
        </Modal>
      )}

      {canDelete && showForceDeleteModal && (
        <Modal
          show={showForceDeleteModal}
          title={labels.forceTitle}
          type="error"
          variant="lds"
          onClose={processing ? () => {} : onCancel}
          dialogClassName="sm:!w-[min(92vw,32rem)] sm:!max-w-none"
          footer={
            <div className="mt-6 grid gap-3 border-t border-slate-200 pt-5 dark:border-slate-700 sm:grid-cols-2">
              <button type="button" onClick={onCancel} disabled={processing} autoFocus className="min-h-11 rounded-xl border border-slate-300 bg-white px-4 py-2.5 text-sm font-bold text-slate-700 transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800 disabled:opacity-50">
                {labels.cancel}
              </button>
              <button
                type="button"
                onClick={onConfirmForceDelete}
                disabled={processing}
                className="min-h-11 rounded-xl bg-red-600 px-4 py-2.5 text-sm font-bold text-white shadow-sm transition hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
              >
                {processing ? labels.processing : labels.confirmForce}
              </button>
            </div>
          }
        >
          <div className="space-y-3 text-sm leading-6 text-slate-700 dark:text-slate-200">
            <p className="font-bold text-red-700 dark:text-red-300">{labels.forceWarning}</p>
            <p>{childName}</p>
            {actionError && <p role="alert" className="font-semibold text-red-600 dark:text-red-300">{actionError}</p>}
          </div>
        </Modal>
      )}

      {showReferenceModal && (
        <Modal
          show={showReferenceModal}
          title={labels.referenceTitle}
          message={
            <div className="space-y-3">
              <p className="text-sm text-gray-700 dark:text-gray-200">{labels.referenceBody}</p>
              {deleteReference && (
                <div className="flex items-center gap-2">
                  <input
                    type="text"
                    readOnly
                    value={deleteReference}
                    className="w-full rounded border bg-gray-50 px-3 py-2 text-sm dark:bg-gray-800"
                  />
                  <button
                    type="button"
                    onClick={onCopyReference}
                    className="whitespace-nowrap rounded-md border border-indigo-200 bg-indigo-50 px-3 py-2 text-sm font-semibold text-indigo-700 hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:border-indigo-500/60 dark:bg-indigo-950/40 dark:text-indigo-200"
                  >
                    {labels.copy}
                  </button>
                </div>
              )}
            </div>
          }
          isConfirm={true}
          type="info"
          confirmText={labels.close}
          onConfirm={onCloseReference}
          onClose={onCloseReference}
        />
      )}

      {showAlumniSuccessModal && (
        <Modal
          show={showAlumniSuccessModal}
          title={labels.alumniSuccessTitle}
          message={labels.alumniSuccessBody}
          type="success"
          onClose={onCloseAlumniSuccess}
        />
      )}
    </>
  );
}
